import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Closing() {
  return <section className="py-24 px-6 bg-gradient-to-b from-brand-bg to-brand-bg-alt relative overflow-hidden" data-id="element-234">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-cyan/5 rounded-full blur-[150px] pointer-events-none" data-id="element-235" />

      <div className="max-w-[1000px] mx-auto relative z-10" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-237">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-238">
            Tienes Dos Caminos Frente a Ti
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-20" data-id="element-239">
          {/* Path A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-red/5 border border-brand-red/30 rounded-[24px] p-8 md:p-10" data-id="element-240">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-241">
              <X className="w-8 h-8 text-brand-red" data-id="element-242" /> Camino A: No Haces Nada
            </h3>
            <ul className="space-y-4" data-id="element-243">
              {['En 6 meses estarás más cansado', 'Más inflamado', 'Más lejos de tu mejor versión', 'El crash de las 3 PM seguirá gobernando tu tarde', 'Tu claridad mental seguirá deteriorándose', 'Y habrás dejado pasar la oferta de lanzamiento'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-244">
                  <div className="w-2 h-2 rounded-full bg-brand-red mt-2 shrink-0" data-id="element-245" />
                  <span className="text-brand-muted leading-relaxed" data-id="element-246">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Path B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-cyan/5 border border-brand-cyan rounded-[24px] p-8 md:p-10 shadow-[0_0_40px_rgba(0,212,170,0.1)]" data-id="element-247">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-248">
              <Check className="w-8 h-8 text-brand-cyan" data-id="element-249" /> Camino B: Activas Tu
              Modo Bio-X
            </h3>
            <ul className="space-y-4" data-id="element-250">
              {['Inviertes menos que una cena de negocios', 'Recibes el ebook + la app completa al instante', 'Mañana despiertas con tu primer protocolo listo', 'En 48 horas notas la primera mejora cognitiva', 'En 14 días, tus colegas preguntan qué hiciste', 'En 30 días, eres una persona diferente biológicamente'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-251">
                  <div className="w-2 h-2 rounded-full bg-brand-cyan mt-2 shrink-0" data-id="element-252" />
                  <span className="text-white font-medium leading-relaxed" data-id="element-253">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Book Visual Above Final CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="relative flex justify-center mb-10" data-id="element-254">
          <div className="absolute inset-0 bg-brand-gold/15 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-255" />
          <img src="https://cdn.magicpatterns.com/uploads/u2Fy8NFvwHuciDc1zswQuT/book2.png" alt="BIO-X 90 — Your complete longevity system" className="relative w-full max-w-[240px] md:max-w-[280px] drop-shadow-[0_25px_50px_rgba(255,215,0,0.15)]" loading="lazy" data-id="element-256" />
        </motion.div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="max-w-[600px] mx-auto bg-gradient-to-br from-brand-cyan/10 to-brand-purple/10 rounded-[24px] p-8 md:p-12 text-center border border-brand-cyan/20" data-id="element-257">
          <div className="mb-8" data-id="element-258">
            <span className="text-brand-red line-through text-2xl font-bold block mb-2" data-id="element-259">
              $505
            </span>
            <span className="text-7xl md:text-8xl font-display font-bold text-brand-gold drop-shadow-[0_0_20px_rgba(255,215,0,0.4)] leading-none block mb-4" data-id="element-260">
              $6.36
            </span>
            <span className="text-white font-medium" data-id="element-261">
              Acceso inmediato de por vida · Ebook + App Completa
            </span>
          </div>

          <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-[72px] rounded-2xl bg-brand-gold text-black font-black text-lg md:text-xl hover:scale-[1.03] transition-transform duration-300 shadow-[0_0_30px_rgba(255,215,0,0.3)] hover:shadow-[0_0_50px_rgba(255,215,0,0.5)] mb-6" data-id="element-262">
            SÍ, QUIERO MEJORAR MI RENDIMIENTO DIARIO — ACCESO COMPLETO POR $6.36
            →
          </a>

          <div className="space-y-2 text-sm text-brand-muted" data-id="element-263">
            <p data-id="element-264">🔒 Pago seguro · 💳 Visa, Master, PayPal</p>
            <p data-id="element-265">🛡️ Garantía 7 días · ⚡ Acceso en 60 segundos</p>
          </div>
        </motion.div>
      </div>
    </section>;
}